var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 12 22 C 17.55 22 22 17.6 22 12.04 C 22.022 6.502 17.538 2 12 2 M 12 22 C 6.45 22 2 17.6 2 12.04 C 1.978 6.502 6.462 2 12 2 M 12 22 C 14.31 22 15.73 19.04 16.26 15.4 M 12 22 C 9.69 22 8.27 19.04 7.74 15.4 M 12 2 C 14.31 2 15.73 4.99 16.26 8.65 M 12 2 C 9.69 2 8.27 4.99 7.74 8.65 M 3.25 8.65 L 7.74 8.65 M 7.74 8.65 L 16.26 8.65 M 7.74 8.65 C 7.425 10.889 7.425 13.161 7.74 15.4 M 16.26 8.65 L 20.75 8.65 M 16.26 8.65 C 16.58 10.83 16.58 13.24 16.26 15.4 M 3.25 15.4 L 7.74 15.4 M 7.74 15.4 L 16.26 15.4 M 16.26 15.4 L 20.75 15.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLine);
export default __webpack_public_path__ + "static/media/web_line.d201d837bfaa2cab03b8551c8d3a901e.svg";
export { ForwardRef as ReactComponent };